import { z } from 'zod';
export const BoardKind = z.enum(['feature', 'support', 'infra', 'agent', 'my-work', 'custom']);
export const BoardColumn = z.object({
    id: z.string(),
    boardConfigId: z.string(),
    name: z.string(),
    description: z.string().nullable(),
    color: z.string().nullable(),
    sortOrder: z.number(),
    mappedStatuses: z.array(z.string()),
    wipLimit: z.number().nullable(),
    allowedTicketTypes: z.array(z.string()).nullable(),
    isDone: z.boolean(),
});
export const BoardConfig = z.object({
    id: z.string(),
    name: z.string(),
    description: z.string().nullable(),
    kind: z.string(),
    ticketTypeFilter: z.string().nullable(),
    queryText: z.string().nullable(),
    ownerId: z.string().nullable(),
    visibility: z.string(),
    isDefault: z.boolean(),
    swimlane: z.string().nullable(),
    cardFields: z.array(z.string()),
    sortOrder: z.number(),
    columns: z.array(BoardColumn),
});
export const CreateBoardColumnInput = z.object({
    name: z.string().min(1),
    description: z.string().optional(),
    color: z.string().optional(),
    mappedStatuses: z.array(z.string()).default([]),
    wipLimit: z.number().nullable().optional(),
    allowedTicketTypes: z.array(z.string()).optional(),
    isDone: z.boolean().optional(),
    sortOrder: z.number().optional(),
});
export const UpdateBoardColumnInput = CreateBoardColumnInput.partial();
export const UpdateBoardConfigInput = z.object({
    name: z.string().optional(),
    description: z.string().optional(),
    swimlane: z.string().optional(),
    cardFields: z.array(z.string()).optional(),
    ticketTypeFilter: z.string().nullable().optional(),
    queryText: z.string().nullable().optional(),
    visibility: z.enum(['private', 'team', 'public']).optional(),
});
/** Fields that can be shown on a board card. */
export const BOARD_CARD_FIELDS = [
    'priority', 'assignee', 'customer', 'tags', 'dueDate', 'sprint', 'release',
    'storyPoints', 'severity', 'parent', 'component',
];
export const BOARD_SWIMLANES = ['none', 'assignee', 'priority', 'epic', 'customer', 'sprint', 'release', 'type'];
//# sourceMappingURL=board.js.map